/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ContractInfoDTO interface.
 */
export function instanceOfContractInfoDTO(value) {
    return true;
}
export function ContractInfoDTOFromJSON(json) {
    return ContractInfoDTOFromJSONTyped(json, false);
}
export function ContractInfoDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'contractId': json['contractId'] == null ? undefined : json['contractId'],
        'externalContractId': json['externalContractId'] == null ? undefined : json['externalContractId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}
export function ContractInfoDTOToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'contractId': value['contractId'],
        'externalContractId': value['externalContractId'],
        'amount': value['amount'],
    };
}
